const baseStyles = ['flex px-7 py-6 w-full'];

export const buttonStyles = [
	...baseStyles,
	// base styles
	'border-stroke-weaker bg-fill-inverse-strong rounded-large elevation-low border-[2px] border-solid',
	// hover styles
	'hover:bg-fill-hover',
	// focus styles
	'focus:border-stroke-focus',
];

export const buttonSelected = [...baseStyles, 'bg-gradient-to-b from-[#F0F7FF] to-blue-100 rounded-[10px]'];
